module.exports = __webpack_public_path__ + "img/img_03@2x.d3350879.png";